import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IS_APP_INITIALIZER } from 'projects/is-ui-kit/src/lib/core/app-initializer/app-initializer.service';
import { IS_INTERCEPTOR } from 'projects/is-ui-kit/src/lib/core/interceptor/interceptor.service';
import { UtilsInitializerModule } from 'projects/is-ui-kit/src/lib/core/utils-initializer/utils-initializer.module';
import { InterceptorModule } from 'projects/is-ui-kit/src/lib/core/interceptor/interceptor.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    UtilsInitializerModule,
    InterceptorModule
  ],
  providers: [
    IS_APP_INITIALIZER,
    IS_INTERCEPTOR
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
